import { useQuery } from 'react-query'
import { axios } from '../../../lib'

export const loadUnities = (): Promise<any> => {
  return axios.get('/customers/unities')
}

export function useLoadUnities() {
  const { data, error, isLoading, isFetching, isPreviousData } = useQuery(
    ['unities'],
    () => loadUnities()
  )
  return { data, error, isLoading, isFetching, isPreviousData }
}
